<template>
  <base-confirm
    :visible="visible"
    :with-cancel="false"
    icon-type="badge"
    title="Update Diperlukan"
    message="Silakan refresh halaman dengan menekan Ctrl + Shift + R untuk mendapatkan versi terbaru aplikasi."
    :confirm-text="`Refresh Halaman`"
    custom-icon-name="heroicons:arrow-path"
    :closable="true"
    @confirmed="onConfirmed"
    @close="visible = false"
  >
    <template #message>
      <p class="text-gray-500">Versi Terbaru: <span class="font-bold text-gray-900">{{ latestVersion }}</span>, silakan refresh halaman dengan menekan <span class="font-bold text-gray-900">Ctrl + Shift + R</span> atau buka kembali halaman ini untuk mendapatkan versi terbaru aplikasi.</p>
    </template>
  </base-confirm>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseConfirm from './base/BaseConfirm.vue';

export default {
  components: {
    BaseConfirm,
  },
  data() {
    return {
      visible: true
      // refreshTimeout: 5,
    };
  },
  computed: {
    ...mapGetters({
      latestVersion: 'auth/getLatestVersion'
    })
  },
  methods: {
    onConfirmed() {
      window.location.reload(true);
    },
  },
  mounted() {
    setTimeout(() => {
      this.visible = false
    }, 15000)
    // setInterval(() => {
    //   this.refreshTimeout--;

    //   if (this.refreshTimeout < 1) {
    //     window.location.reload(true)
    //   }
    // }, 1000);
  },
};
</script>
